export default "__VITE_ASSET__KK0mNGJl__"